import { render } from "./create-org-support-case.vue?vue&type=template&id=45de46b4"
import script from "./create-org-support-case.vue?vue&type=script&lang=js"
export * from "./create-org-support-case.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__